var Opal = require('../opal').default; /* Generated by Opal 0.11.99.dev */
(function(Opal) {
  function $rb_le(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs <= rhs : lhs['$<='](rhs);
  }
  function $rb_ge(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs >= rhs : lhs['$>='](rhs);
  }
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $send = Opal.send, $truthy = Opal.truthy, $hash2 = Opal.hash2;

  Opal.add_stubs(['$==', '$<=', '$>=', '$===', '$get_emotion_table', '$get_accident_table', '$get_nichijyou_event_table', '$get_kouryu_event_table', '$get_asobi_event_table', '$get_ensyuu_event_table', '$get_ensei_event_table', '$get_sakusen_event_table', '$get_honobono_event_table', '$get_voyage_event_table', '$get_gaisyutsu_event_table', '$get_battle_event_table', '$get_mission_event_table', '$get_fear_event_table', '$get_develop_table', '$get_develop_matome_table', '$get_weapon1_table', '$get_weapon2_table', '$get_weapon3_table', '$get_weapon4_table', '$get_item_table', '$get_mokuhyou_table', '$get_senka_table', '$get_special_senka_table', '$get_kosei_table', '$get_bunya_table', '$get_kosei_haikei_table', '$get_kosei_miryoku_table', '$get_kosei_seikaku_table', '$get_kosei_syumi_table', '$get_kosei_koukai_table', '$get_kosei_sentou_table', '$get_senzyou_table', '$get_bousou_table', '$getTableCommandResult', '$get_table_by_1d6', '$each', '$gsub!', '$get_table_by_2d6', '$roll', '$setPrefixes', '$+', '$keys']);
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'KanColle');

    var $nesting = [self].concat($parent_nesting), $KanColle_initialize$1, $KanColle_gameName$2, $KanColle_gameType$3, $KanColle_getHelpMessage$4, $KanColle_check_2D6$5, $KanColle_rollDiceCommand$6, $KanColle_get_emotion_table$7, $KanColle_get_accident_table$8, $KanColle_get_nichijyou_event_table$9, $KanColle_get_kouryu_event_table$11, $KanColle_get_asobi_event_table$13, $KanColle_get_ensyuu_event_table$15, $KanColle_get_ensei_event_table$17, $KanColle_get_sakusen_event_table$19, $KanColle_get_honobono_event_table$21, $KanColle_get_voyage_event_table$23, $KanColle_get_gaisyutsu_event_table$25, $KanColle_get_battle_event_table$27, $KanColle_get_mission_event_table$29, $KanColle_get_fear_event_table$31, $KanColle_get_develop_table$33, $KanColle_get_develop_matome_table$34, $KanColle_get_weapon1_table$35, $KanColle_get_weapon2_table$36, $KanColle_get_weapon3_table$37, $KanColle_get_weapon4_table$38, $KanColle_get_item_table$39, $KanColle_get_mokuhyou_table$41, $KanColle_get_senka_table$42, $KanColle_get_special_senka_table$43, $KanColle_get_kosei_table$44, $KanColle_get_bunya_table$45, $KanColle_get_kosei_haikei_table$46, $KanColle_get_kosei_miryoku_table$47, $KanColle_get_kosei_seikaku_table$48, $KanColle_get_kosei_syumi_table$49, $KanColle_get_kosei_koukai_table$50, $KanColle_get_kosei_sentou_table$51, $KanColle_get_senzyou_table$52, $KanColle_get_bousou_table$54, $a;

    
    
    Opal.def(self, '$initialize', $KanColle_initialize$1 = function $$initialize() {
      var $iter = $KanColle_initialize$1.$$p, $yield = $iter || nil, self = this, $zuper = nil, $zuper_i = nil, $zuper_ii = nil;

      if ($iter) $KanColle_initialize$1.$$p = null;
      // Prepare super implicit arguments
      for($zuper_i = 0, $zuper_ii = arguments.length, $zuper = new Array($zuper_ii); $zuper_i < $zuper_ii; $zuper_i++) {
        $zuper[$zuper_i] = arguments[$zuper_i];
      }
      
      $send(self, Opal.find_super_dispatcher(self, 'initialize', $KanColle_initialize$1, false), $zuper, $iter);
      self.sendMode = 2;
      self.sortType = 3;
      return (self.d66Type = 2);
    }, $KanColle_initialize$1.$$arity = 0);
    
    Opal.def(self, '$gameName', $KanColle_gameName$2 = function $$gameName() {
      var self = this;

      return "艦これRPG"
    }, $KanColle_gameName$2.$$arity = 0);
    
    Opal.def(self, '$gameType', $KanColle_gameType$3 = function $$gameType() {
      var self = this;

      return "KanColle"
    }, $KanColle_gameType$3.$$arity = 0);
    
    Opal.def(self, '$getHelpMessage', $KanColle_getHelpMessage$4 = function $$getHelpMessage() {
      var self = this;

      return "" + "例) 2D6 ： 単純に2D6した値を出します。\n" + "例) 2D6>=7 ： 行為判定。2D6して目標値7以上出れば成功。\n" + "例) 2D6+2>=7 ： 行為判定。2D6に修正+2をした上で目標値7以上になれば成功。\n" + "\n" + "2D6での行為判定時は1ゾロでファンブル、6ゾロでスペシャル扱いになります。\n" + "天龍ちゃんスペシャルは手動で判定してください。\n" + "\n" + "・各種表\n" + "　・感情表　ET／アクシデント表　ACT\n" + "　・日常イベント表　EVNT／交流イベント表　EVKT／遊びイベント表　EVAT\n" + "　　演習イベント表　EVET／遠征イベント表　EVENT／作戦イベント表　EVST\n" + "　・ほのぼのイベント表　ETHT／航海イベント表　ETVT　外出イベント表　ETGT\n" + "　　激戦イベント表　ETBT／任務イベント表　ETMT／恐怖イベント表　ETFT／侵攻効果表　ETIT\n" + "　・大規模部隊表 LSFT／艦隊敗北表 LFDT／艦隊勝利表 LFVT\n" + "　・開発表　DVT／開発表（一括）DVTM\n" + "　　　装備１種表　WP1T／装備２種表　WP2T／装備３種表　WP3T／装備４種表　WP4T\n" + "　・アイテム表　ITT／目標表　MHT／戦果表　SNT／特殊戦果表　SPSNT\n" + "　・ランダム個性選択：一括　KTM／分野　BT\n" + "　　　背景　KHT／魅力　KMT／性格　KST／趣味　KSYT／航海　KKT／戦闘　KSNT\n" + "　・戦場表　SNZ　暴走表／RNT\n" + "　・特殊開発表　WPMC　(燃料6/弾薬3/鋼材6/ボーキ3)\n" + "　・新・特殊開発表　WPMCN\n" + "　・艦載機関開発表　WPFA　(燃料3/弾薬6/鋼材3/ボーキ6)\n" + "　・砲類開発表　WPCN　(燃料3/弾薬6/鋼材6/ボーキ3)　\n" + "　・敵深海棲艦の装備決定 BT2～BT12\n" + "・D66ダイス(D66S相当=低い方が10の桁になる)\n"
    }, $KanColle_getHelpMessage$4.$$arity = 0);
    
    Opal.def(self, '$check_2D6', $KanColle_check_2D6$5 = function $$check_2D6(total_n, dice_n, signOfInequality, diff, dice_cnt, dice_max, n1, n_max) {
      var self = this;

      
      if ($truthy(signOfInequality['$=='](">="))) {
      } else {
        return ""
      };
      if ($truthy($rb_le(dice_n, 2))) {
        return " ＞ ファンブル（判定失敗。アクシデント表を自分のＰＣに適用）"
      } else if ($truthy($rb_ge(dice_n, 12))) {
        return " ＞ スペシャル（判定成功。【行動力】が１Ｄ６点回復）"
      } else if ($truthy($rb_ge(total_n, diff))) {
        return " ＞ 成功"
      } else {
        return " ＞ 失敗"
      };
    }, $KanColle_check_2D6$5.$$arity = 8);
    
    Opal.def(self, '$rollDiceCommand', $KanColle_rollDiceCommand$6 = function $$rollDiceCommand(command) {
      var $a, $b, self = this, output = nil, type = nil, total_n = nil, $case = nil;

      
      output = "1";
      type = "";
      total_n = "";
      $case = command;
      if ("ET"['$===']($case)) {
      type = "感情表";
      $b = self.$get_emotion_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("ACT"['$===']($case)) {
      type = "アクシデント表";
      $b = self.$get_accident_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("EVNT"['$===']($case)) {
      type = "日常イベント表";
      $b = self.$get_nichijyou_event_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("EVKT"['$===']($case)) {
      type = "交流イベント表";
      $b = self.$get_kouryu_event_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("EVAT"['$===']($case)) {
      type = "遊びイベント表";
      $b = self.$get_asobi_event_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("EVET"['$===']($case)) {
      type = "演習イベント表";
      $b = self.$get_ensyuu_event_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("EVENT"['$===']($case)) {
      type = "遠征イベント表";
      $b = self.$get_ensei_event_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("EVST"['$===']($case)) {
      type = "作戦イベント表";
      $b = self.$get_sakusen_event_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("ETHT"['$===']($case)) {
      type = "ほのぼのイベント表";
      $b = self.$get_honobono_event_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("ETVT"['$===']($case)) {
      type = "航海イベント表";
      $b = self.$get_voyage_event_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("ETGT"['$===']($case)) {
      type = "外出イベント表";
      $b = self.$get_gaisyutsu_event_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("ETBT"['$===']($case)) {
      type = "激戦イベント表";
      $b = self.$get_battle_event_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("ETMT"['$===']($case)) {
      type = "任務イベント表";
      $b = self.$get_mission_event_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("ETFT"['$===']($case)) {
      type = "恐怖イベント表";
      $b = self.$get_fear_event_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("DVT"['$===']($case)) {
      type = "開発表";
      $b = self.$get_develop_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("DVTM"['$===']($case)) {
      type = "開発表（一括）";
      $b = self.$get_develop_matome_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("WP1T"['$===']($case)) {
      type = "装備１種表";
      $b = self.$get_weapon1_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("WP2T"['$===']($case)) {
      type = "装備２種表";
      $b = self.$get_weapon2_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("WP3T"['$===']($case)) {
      type = "装備３種表";
      $b = self.$get_weapon3_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("WP4T"['$===']($case)) {
      type = "装備４種表";
      $b = self.$get_weapon4_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("ITT"['$===']($case)) {
      type = "アイテム表";
      $b = self.$get_item_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("MHT"['$===']($case)) {
      type = "目標表";
      $b = self.$get_mokuhyou_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("SNT"['$===']($case)) {
      type = "戦果表";
      $b = self.$get_senka_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("SPSNT"['$===']($case)) {
      type = "特殊戦果表";
      $b = self.$get_special_senka_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("KTM"['$===']($case)) {
      type = "個性：一括";
      $b = self.$get_kosei_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("BT"['$===']($case)) {
      type = "個性：分野表";
      $b = self.$get_bunya_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("KHT"['$===']($case)) {
      type = "個性：背景表";
      $b = self.$get_kosei_haikei_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("KMT"['$===']($case)) {
      type = "個性：魅力表";
      $b = self.$get_kosei_miryoku_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("KST"['$===']($case)) {
      type = "個性：性格表";
      $b = self.$get_kosei_seikaku_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("KSYT"['$===']($case)) {
      type = "個性：趣味表";
      $b = self.$get_kosei_syumi_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("KKT"['$===']($case)) {
      type = "個性：航海表";
      $b = self.$get_kosei_koukai_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("KSNT"['$===']($case)) {
      type = "個性：戦闘表";
      $b = self.$get_kosei_sentou_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("SNZ"['$===']($case)) {
      type = "戦場表";
      $b = self.$get_senzyou_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else if ("RNT"['$===']($case)) {
      type = "暴走表";
      $b = self.$get_bousou_table(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (total_n = ($a[1] == null ? nil : $a[1])), $b;}
      else {return self.$getTableCommandResult(command, (($a = $nesting[0].$$cvars['@@tables']) == null ? nil : $a))};
      return "" + (type) + "(" + (total_n) + ") ＞ " + (output);
    }, $KanColle_rollDiceCommand$6.$$arity = 1);
    
    Opal.def(self, '$get_emotion_table', $KanColle_get_emotion_table$7 = function $$get_emotion_table() {
      var self = this, table = nil;

      
      table = ["かわいい（プラス）／むかつく（マイナス）", "すごい（プラス）／ざんねん（マイナス）", "たのしい（プラス）／こわい（マイナス）", "かっこいい（プラス）／しんぱい（マイナス）", "いとしい（プラス）／かまってほしい（マイナス）", "だいすき（プラス）／だいっきらい（マイナス）"];
      return self.$get_table_by_1d6(table);
    }, $KanColle_get_emotion_table$7.$$arity = 0);
    
    Opal.def(self, '$get_accident_table', $KanColle_get_accident_table$8 = function $$get_accident_table() {
      var self = this, table = nil;

      
      table = ["よかったぁ。何もなし。", "意外な手応え。その判定に使った個性の属性（【長所】と【弱点】）が反対になる。自分が判定を行うとき以外はこの効果は無視する。", "えーん。大失態。このキャラクターに対して【感情値】を持っているキャラクター全員の声援欄にチェックが入る。", "奇妙な猫がまとわりつく。サイクルの終了時、もしくは、艦隊戦の終了時まで、自分の行う行為判定にマイナス１の修正がつく（この効果は、マイナス２まで累積する）。", "いててて。損傷が一つ発生する。もしも艦隊戦中なら、自分と同じ航行序列にいる味方艦にも損傷が一つ発生する。", "ううう。やりすぎちゃった！自分の【行動力】が１Ｄ６点減少する。"];
      return self.$get_table_by_1d6(table);
    }, $KanColle_get_accident_table$8.$$arity = 0);
    
    Opal.def(self, '$get_nichijyou_event_table', $KanColle_get_nichijyou_event_table$9 = function $$get_nichijyou_event_table() {
      var $$10, self = this, table = nil;

      
      table = ["何もない日々：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は、《待機／航海７》で判定。", "ティータイム：《外国暮らし／背景１２》で判定。", "釣り：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《おおらか／性格３》で判定。", "お昼寝：《寝る／趣味２》で判定。", "綺麗におそうじ！：《衛生／航海１１》で判定。", "海軍カレー：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《食べ物／趣味６》で判定。", "銀蝿／ギンバイ：《規律／航海５》で判定。", "日々の訓練：《素直／魅力２》で判定。", "取材：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《名声／背景３》で判定。", "海水浴：《突撃／戦闘６》で判定。", "マイブーム：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《口ぐせ／背景６》で判定。"];
      $send(table, 'each', [], ($$10 = function(i){var self = $$10.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$gsub!'](/$/, "（着任p220）");}, $$10.$$s = self, $$10.$$arity = 1, $$10));
      return self.$get_table_by_2d6(table);
    }, $KanColle_get_nichijyou_event_table$9.$$arity = 0);
    
    Opal.def(self, '$get_kouryu_event_table', $KanColle_get_kouryu_event_table$11 = function $$get_kouryu_event_table() {
      var $$12, self = this, table = nil;

      
      table = ["一触即発！：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《笑顔／魅力７》で判定。", "手取り足取り：自分以外の好きなＰＣ１人を選んで、《えっち／魅力１１》で判定。", "恋は戦争：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《恋愛／趣味１２》で判定。", "マッサージ：自分以外の好きなＰＣ１人を選んで、《けなげ／魅力６》で判定。", "裸のつきあい：《入浴／趣味１１》で判定。", "深夜のガールズトーク：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《おしゃべり／趣味７》で判定。", "いいまちがえ：《ばか／魅力８》で判定。", "小言百より慈愛の一語：自分以外の好きなＰＣ１人を選んで、《面倒見／性格４》で判定。", "差し入れ：自分以外の好きなＰＣ１人を選んで、提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《優しい／魅力４》で判定。", "お手紙：自分以外の好きなＰＣ１人を選んで、《古風／背景５》で判定。", "昔語り：自分以外の好きなＰＣ１人を選んで、提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《暗い過去／背景４》で判定。"];
      $send(table, 'each', [], ($$12 = function(i){var self = $$12.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$gsub!'](/$/, "（着任p221）");}, $$12.$$s = self, $$12.$$arity = 1, $$12));
      return self.$get_table_by_2d6(table);
    }, $KanColle_get_kouryu_event_table$11.$$arity = 0);
    
    Opal.def(self, '$get_asobi_event_table', $KanColle_get_asobi_event_table$13 = function $$get_asobi_event_table() {
      var $$14, self = this, table = nil;

      
      table = ["遊びのつもりが……：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《さわやか／魅力９》で判定。", "新しい遊びの開発：《空想／趣味３》で判定。", "宴会：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《元気／性格７》で判定。", "街をぶらつく：《面白い／魅力１０》で判定。", "ガールズコーデ：《おしゃれ／趣味１０》で判定。", "○○大会開催！：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《大胆／性格１２》で判定。", "チェス勝負：自分以外の好きなＰＣ１人を選んで、《クール／魅力３》で判定。", "熱唱カラオケ大会：《芸能／趣味９》で判定。", "アイドルコンサート：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《アイドル／背景８》で判定。", "スタイル自慢！：《スタイル／背景１１》で判定。", "ちゃんと面倒みるから！：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《生き物／趣味４》で判定。"];
      $send(table, 'each', [], ($$14 = function(i){var self = $$14.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$gsub!'](/$/, "（着任p222）");}, $$14.$$s = self, $$14.$$arity = 1, $$14));
      return self.$get_table_by_2d6(table);
    }, $KanColle_get_asobi_event_table$13.$$arity = 0);
    
    Opal.def(self, '$get_ensyuu_event_table', $KanColle_get_ensyuu_event_table$15 = function $$get_ensyuu_event_table() {
      var $$16, self = this, table = nil;

      
      table = ["大げんか！：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《負けず嫌い／性格６》で判定。", "雷撃演習：《魚雷／戦闘１０》で判定。", "座学の講義：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《マジメ／性格５》で判定。", "速力演習：《機動／航海８》で判定。", "救援演習：《支援／戦闘９》で判定。シーンプレイヤーのＰＣは、経験点を１０点獲得する。残念：ＰＣ全員の【行動力】が１Ｄ６点減少する。", "砲撃演習：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《砲撃／戦闘７》で判定。", "艦隊戦演習：《派手／魅力１２》で判定。", "整備演習：《整備／航海１２》で判定。", "夜戦演習：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《夜戦／戦闘１２》で判定。", "開発演習：《秘密兵器／背景９》で判定。", "防空射撃演習：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《対空戦闘／戦闘５》で判定。"];
      $send(table, 'each', [], ($$16 = function(i){var self = $$16.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$gsub!'](/$/, "（着任p223）");}, $$16.$$s = self, $$16.$$arity = 1, $$16));
      return self.$get_table_by_2d6(table);
    }, $KanColle_get_ensyuu_event_table$15.$$arity = 0);
    
    Opal.def(self, '$get_ensei_event_table', $KanColle_get_ensei_event_table$17 = function $$get_ensei_event_table() {
      var $$18, self = this, table = nil;

      
      table = ["謎の深海棲艦：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《退却／戦闘８》で判定。", "資源輸送任務：《買い物／趣味８》で判定。", "強行偵察任務：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《索敵／航海４》で判定。", "航空機輸送作戦：《航空戦／戦闘４》で判定。", "タンカー護衛任務：《丁寧／性格９》で判定。", "海上護衛任務：提督が選んだ（キーワード）に対応した指定能力で判定。思いつかない場合は《不思議／性格２》で判定。", "観艦式：《おしとやか／魅力５》で判定。", "ボーキサイト輸送任務：《補給／航海６》で判定。", "社交界デビュー？：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《お嬢様／背景１０》で判定。", "対潜警戒任務：《対潜戦闘／戦闘１１》で判定。", "大規模遠征作戦、発令！：提督の選んだ（キーワード）に対応した指定能力値で判定。思いつかな場合は《指揮／航海１０》で判定。"];
      $send(table, 'each', [], ($$18 = function(i){var self = $$18.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$gsub!'](/$/, "（着任p224）");}, $$18.$$s = self, $$18.$$arity = 1, $$18));
      return self.$get_table_by_2d6(table);
    }, $KanColle_get_ensei_event_table$17.$$arity = 0);
    
    Opal.def(self, '$get_sakusen_event_table', $KanColle_get_sakusen_event_table$19 = function $$get_sakusen_event_table() {
      var $$20, self = this, table = nil;

      
      table = ["電子の目：提督が選んだ(キーワード)に対応した指定個性で判定。思いつかない場合は《電子戦／戦闘２》で判定。", "直掩部隊：《航空戦／戦闘４》で判定。", "噂によれば：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《通信／航海３》で判定。", "資料室にて：《海図／航海９》で判定。", "守護天使：《幸運／背景７》で判定。", "作戦会議！：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《自由奔放／性格１１》で判定。", "暗号解読：《暗号／航海２》で判定。", "一か八か？：《楽観的／性格８》で判定。", "特務機関との邂逅：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《人脈／背景２》で判定。", "クイーンズ・ギャンビット：《いじわる／性格１０》で判定。", "知彼知己者、百戦不殆：《読書／趣味５》で判定。"];
      $send(table, 'each', [], ($$20 = function(i){var self = $$20.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$gsub!'](/$/, "（着任p225）");}, $$20.$$s = self, $$20.$$arity = 1, $$20));
      return self.$get_table_by_2d6(table);
    }, $KanColle_get_sakusen_event_table$19.$$arity = 0);
    
    Opal.def(self, '$get_honobono_event_table', $KanColle_get_honobono_event_table$21 = function $$get_honobono_event_table() {
      var $$22, self = this, table = nil;

      
      table = ["模様替え：提督が選んだ(キーワード)に対応した指定個性で判定。思いつかない場合は《派手／魅力１２》で判定。", "門限破り：《夜戦／戦闘１２》で判定。", "ぼやき大会：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《いじわる／性格１０》で判定。", "もしも……：《自由奔放／性格１１》で判定。", "退屈な会議：《暗号／航海２》で判定。", "気の合う趣味：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《面白い／魅力１０》で判定。", "身だしなみ：《さわやか／魅力９》で判定。", "ダイエット：《スタイル／背景１１》で判定。", "通信販売：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《待機／背景２》で判定。", "気になる視線：《えっち／魅力１１》で判定。", "思い立ったが吉日：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《恋愛／趣味１２》で判定。"];
      $send(table, 'each', [], ($$22 = function(i){var self = $$22.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$gsub!'](/$/, "（建造弐p134）");}, $$22.$$s = self, $$22.$$arity = 1, $$22));
      return self.$get_table_by_2d6(table);
    }, $KanColle_get_honobono_event_table$21.$$arity = 0);
    
    Opal.def(self, '$get_voyage_event_table', $KanColle_get_voyage_event_table$23 = function $$get_voyage_event_table() {
      var $$24, self = this, table = nil;

      
      table = ["厳しくいくぞ：提督が選んだ(キーワード)に対応した指定個性で判定。思いつかない場合は《規律／航海５》で判定。", "密航者：《笑顔／魅力７》で判定。", "不審の目：《外国暮らし／背景１２》で判定。", "危険海域：《海図／航海９》で判定。", "波間の影：《砲撃／戦闘７》で判定。", "ホームシック：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《支援／戦闘９》で判定。", "追跡者：《対潜戦闘／戦闘１１》で判定。", "大嵐：《機動／航海８》で判定。", "うち捨てられた基地：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《読書／趣味５》で判定。", "ネズミ上陸：《衛生／航海１１》で判定。", "味の探求：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《読書／趣味５》で判定。"];
      $send(table, 'each', [], ($$24 = function(i){var self = $$24.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$gsub!'](/$/, "（建造弐p135）");}, $$24.$$s = self, $$24.$$arity = 1, $$24));
      return self.$get_table_by_2d6(table);
    }, $KanColle_get_voyage_event_table$23.$$arity = 0);
    
    Opal.def(self, '$get_gaisyutsu_event_table', $KanColle_get_gaisyutsu_event_table$25 = function $$get_gaisyutsu_event_table() {
      var $$26, self = this, table = nil;

      
      table = ["ノブレス・オブリージュ：提督が選んだ(キーワード)に対応した指定個性で判定。思いつかない場合は《お嬢様／背景１０》で判定。", "サイン会：《名声／背景３》で判定。", "蚤の市：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《古風／背景５》で判定。", "追っかけ：《退却／戦闘８》で判定。", "走り込み：《航空戦／戦闘４》で判定。", "外食：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《索敵／航海４》で判定。", "迷子：《面倒見／性格４》で判定。", "街頭モデル：《おしゃれ／趣味１０》で判定。", "暴れ○○だ！：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《生き物／趣味４》で判定。", "臨時講師：《おしゃべり／性格１０》で判定。", "映画撮影：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《芸能／趣味９》で判定。"];
      $send(table, 'each', [], ($$26 = function(i){var self = $$26.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$gsub!'](/$/, "（建造弐p136）");}, $$26.$$s = self, $$26.$$arity = 1, $$26));
      return self.$get_table_by_2d6(table);
    }, $KanColle_get_gaisyutsu_event_table$25.$$arity = 0);
    
    Opal.def(self, '$get_battle_event_table', $KanColle_get_battle_event_table$27 = function $$get_battle_event_table() {
      var $$28, self = this, table = nil;

      
      table = ["分裂の危機：提督が選んだ(キーワード)に対応した指定個性で判定。思いつかない場合は《指揮／航海１０》で判定。", "脱走：《通信／航海３》で判定。", "勇気の呪文：《口ぐせ／背景６》で判定。", "混乱：《整備／航海１２》で判定。", "不意の遭遇：《魚雷／戦闘１０》で判定。", "敵の襲撃：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《大胆／性格１２》で判定。", "対空迎撃戦：《対空戦闘／戦闘５》で判定。", "傷自慢：《元気／性格７》で判定。", "怖がらないで：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《優しい／魅力４》で判定。", "生き延びろ：《負けず嫌い／性格１０》で判定。", "極限の集中：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《ばか／魅力８》で判定。"];
      $send(table, 'each', [], ($$28 = function(i){var self = $$28.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$gsub!'](/$/, "（建造弐p137）");}, $$28.$$s = self, $$28.$$arity = 1, $$28));
      return self.$get_table_by_2d6(table);
    }, $KanColle_get_battle_event_table$27.$$arity = 0);
    
    Opal.def(self, '$get_mission_event_table', $KanColle_get_mission_event_table$29 = function $$get_mission_event_table() {
      var $$30, self = this, table = nil;

      
      table = ["視察：提督が選んだ(キーワード)に対応した指定個性で判定。思いつかない場合は《面倒見／魅力１２》で判定。", "酒保祭り：《補給／航海６》で判定。", "アイドルユニット結成：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《アイドル／背景８》で判定。", "お風呂場大改造：《入浴／趣味１１》で判定。", "現場の融通：《人脈／背景２》で判定。", "緊急空輸：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《航空戦／戦闘４》で判定。", "資源の再利用：《マジメ／性格５》で判定。", "物欲：《買い物／趣味８》で判定。", "魔改造：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《秘密兵器／背景９》で判定。", "ちゃんと伝えたってば！：《クール／魅力３》で判定。", "ストライキ：《おおらか／性格３》で判定。"];
      $send(table, 'each', [], ($$30 = function(i){var self = $$30.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$gsub!'](/$/, "（建造弐p138）");}, $$30.$$s = self, $$30.$$arity = 1, $$30));
      return self.$get_table_by_2d6(table);
    }, $KanColle_get_mission_event_table$29.$$arity = 0);
    
    Opal.def(self, '$get_fear_event_table', $KanColle_get_fear_event_table$31 = function $$get_fear_event_table() {
      var $$32, self = this, table = nil;

      
      table = ["未知の怪物：提督が選んだ(キーワード)に対応した指定個性で判定。思いつかない場合は《突撃／戦闘６》で判定。", "ドッペルゲンガー：《不思議／性格２》で判定。", "悪夢：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《寝る／趣味２》で判定。", "イマジナリーフレンド：《空想／趣味３》で判定。", "幽霊船：《電子戦／戦闘２》で判定。", "謎の予言：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《楽観的／性格８》で判定。", "黒猫：《幸運／背景７》で判定。", "サルベージ：《丁寧／性格９》で判定。", "フラッシュバック：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《暗い過去／背景４》で判定。", "深海の呼び声：《素直／魅力２》で判定。", "死者の声：提督が選んだ（キーワード）に対応した指定個性で判定。思いつかない場合は《けなげ／魅力６》で判定。"];
      $send(table, 'each', [], ($$32 = function(i){var self = $$32.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$gsub!'](/$/, "（建造弐p139）");}, $$32.$$s = self, $$32.$$arity = 1, $$32));
      return self.$get_table_by_2d6(table);
    }, $KanColle_get_fear_event_table$31.$$arity = 0);
    
    Opal.def(self, '$get_develop_table', $KanColle_get_develop_table$33 = function $$get_develop_table() {
      var self = this, table = nil;

      
      table = ["装備１種表（WP1T）", "装備１種表（WP1T）", "装備２種表（WP2T）", "装備２種表（WP2T）", "装備３種表（WP3T）", "装備４種表（WP4T）"];
      return self.$get_table_by_1d6(table);
    }, $KanColle_get_develop_table$33.$$arity = 0);
    
    Opal.def(self, '$get_develop_matome_table', $KanColle_get_develop_matome_table$34 = function $$get_develop_matome_table() {
      var $a, $b, self = this, output1 = nil, output2 = nil, total_n2 = nil, dice = nil, $case = nil, result = nil, number = nil;

      
      output1 = "";
      output2 = "";
      total_n2 = "";
      $b = self.$roll(1, 6), $a = Opal.to_ary($b), (dice = ($a[0] == null ? nil : $a[0])), $b;
      $case = dice;
      if ((1)['$===']($case)) {
      output1 = "装備１種表";
      $b = self.$get_weapon1_table(), $a = Opal.to_ary($b), (output2 = ($a[0] == null ? nil : $a[0])), (total_n2 = ($a[1] == null ? nil : $a[1])), $b;}
      else if ((2)['$===']($case)) {
      output1 = "装備１種表";
      $b = self.$get_weapon1_table(), $a = Opal.to_ary($b), (output2 = ($a[0] == null ? nil : $a[0])), (total_n2 = ($a[1] == null ? nil : $a[1])), $b;}
      else if ((3)['$===']($case)) {
      output1 = "装備２種表";
      $b = self.$get_weapon2_table(), $a = Opal.to_ary($b), (output2 = ($a[0] == null ? nil : $a[0])), (total_n2 = ($a[1] == null ? nil : $a[1])), $b;}
      else if ((4)['$===']($case)) {
      output1 = "装備２種表";
      $b = self.$get_weapon2_table(), $a = Opal.to_ary($b), (output2 = ($a[0] == null ? nil : $a[0])), (total_n2 = ($a[1] == null ? nil : $a[1])), $b;}
      else if ((5)['$===']($case)) {
      output1 = "装備３種表";
      $b = self.$get_weapon3_table(), $a = Opal.to_ary($b), (output2 = ($a[0] == null ? nil : $a[0])), (total_n2 = ($a[1] == null ? nil : $a[1])), $b;}
      else if ((6)['$===']($case)) {
      output1 = "装備４種表";
      $b = self.$get_weapon4_table(), $a = Opal.to_ary($b), (output2 = ($a[0] == null ? nil : $a[0])), (total_n2 = ($a[1] == null ? nil : $a[1])), $b;};
      result = "" + (output1) + "：" + (output2);
      number = "" + (dice) + "," + (total_n2);
      return [result, number];
    }, $KanColle_get_develop_matome_table$34.$$arity = 0);
    
    Opal.def(self, '$get_weapon1_table', $KanColle_get_weapon1_table$35 = function $$get_weapon1_table() {
      var self = this, table = nil;

      
      table = ["小口径主砲（P249）", "１０ｃｍ連装高角砲（P249）", "中口径主砲（P249）", "１５．２ｃｍ連装砲（P249）", "２０．３ｃｍ連装砲（P249）", "魚雷（P252）"];
      return self.$get_table_by_1d6(table);
    }, $KanColle_get_weapon1_table$35.$$arity = 0);
    
    Opal.def(self, '$get_weapon2_table', $KanColle_get_weapon2_table$36 = function $$get_weapon2_table() {
      var self = this, table = nil;

      
      table = ["副砲（P250）", "８ｃｍ高角砲（P250）", "大口径主砲（P249）", "４１ｃｍ連装砲（P250）", "４６ｃｍ三連装砲（P250）", "機銃（P252）"];
      return self.$get_table_by_1d6(table);
    }, $KanColle_get_weapon2_table$36.$$arity = 0);
    
    Opal.def(self, '$get_weapon3_table', $KanColle_get_weapon3_table$37 = function $$get_weapon3_table() {
      var self = this, table = nil;

      
      table = ["艦上爆撃機（P250）", "艦上攻撃機（P251）", "艦上戦闘機（P251）", "偵察機（P251）", "電探（P252）", "２５ｍｍ連装機銃（P252）"];
      return self.$get_table_by_1d6(table);
    }, $KanColle_get_weapon3_table$37.$$arity = 0);
    
    Opal.def(self, '$get_weapon4_table', $KanColle_get_weapon4_table$38 = function $$get_weapon4_table() {
      var self = this, table = nil;

      
      table = ["彗星（P250）", "天山（P251）", "零式艦戦５２型（P251）", "彩雲（P251）", "６１ｃｍ四連装（酸素）魚雷（P252）", "改良型艦本式タービン（P252）"];
      return self.$get_table_by_1d6(table);
    }, $KanColle_get_weapon4_table$38.$$arity = 0);
    
    Opal.def(self, '$get_item_table', $KanColle_get_item_table$39 = function $$get_item_table() {
      var $$40, self = this, table = nil;

      
      table = ["アイス", "羊羹", "開発資材", "高速修復剤", "応急修理要員", "思い出の品"];
      $send(table, 'each', [], ($$40 = function(i){var self = $$40.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$gsub!'](/$/, "（P241）");}, $$40.$$s = self, $$40.$$arity = 1, $$40));
      return self.$get_table_by_1d6(table);
    }, $KanColle_get_item_table$39.$$arity = 0);
    
    Opal.def(self, '$get_mokuhyou_table', $KanColle_get_mokuhyou_table$41 = function $$get_mokuhyou_table() {
      var self = this, table = nil;

      
      table = ["敵艦の中で、もっとも航行序列の高いＰＣ", "敵艦の中で、もっとも損傷の多いＰＣ", "敵艦の中で、もっとも【装甲力】の低いＰＣ", "敵艦の中で、もっとも【回避力】の低いＰＣ", "敵艦の中で、もっとも【火力】の高いＰＣ", "敵艦の中から完全にランダムに決定"];
      return self.$get_table_by_1d6(table);
    }, $KanColle_get_mokuhyou_table$41.$$arity = 0);
    
    Opal.def(self, '$get_senka_table', $KanColle_get_senka_table$42 = function $$get_senka_table() {
      var self = this, table = nil;

      
      table = ["燃料／１Ｄ６＋[敵艦隊の人数]個", "弾薬／１Ｄ６＋[敵艦隊の人数]個", "鋼材／１Ｄ６＋[敵艦隊の人数]個", "ボーキサイト／１Ｄ６＋[敵艦隊の人数]個", "任意の資材／１Ｄ６＋[敵艦隊の人数]個", "感情値／各自好きなキャラクターへの【感情値】＋１"];
      return self.$get_table_by_1d6(table);
    }, $KanColle_get_senka_table$42.$$arity = 0);
    
    Opal.def(self, '$get_special_senka_table', $KanColle_get_special_senka_table$43 = function $$get_special_senka_table() {
      var self = this, table = nil;

      
      table = ["すべての資材／＋３", "アイテム表(着任p241)から好きなアイテムを取得", "家具コイン／＋１", "砲類開発表を使用する(資材は消費しない)", "艦載機開発表を使用する(資材は消費しない)", "新特殊開発表を使用する(資材は消費しない)"];
      return self.$get_table_by_1d6(table);
    }, $KanColle_get_special_senka_table$43.$$arity = 0);
    
    Opal.def(self, '$get_kosei_table', $KanColle_get_kosei_table$44 = function $$get_kosei_table() {
      var $a, $b, self = this, output1 = nil, output2 = nil, total_n2 = nil, total_n1 = nil, $case = nil, result = nil, number = nil;

      
      output1 = "";
      output2 = "";
      total_n2 = "";
      $b = self.$get_bunya_table(), $a = Opal.to_ary($b), (output1 = ($a[0] == null ? nil : $a[0])), (total_n1 = ($a[1] == null ? nil : $a[1])), $b;
      $case = total_n1;
      if ((1)['$===']($case)) {$b = self.$get_kosei_haikei_table(), $a = Opal.to_ary($b), (output2 = ($a[0] == null ? nil : $a[0])), (total_n2 = ($a[1] == null ? nil : $a[1])), $b}
      else if ((2)['$===']($case)) {$b = self.$get_kosei_miryoku_table(), $a = Opal.to_ary($b), (output2 = ($a[0] == null ? nil : $a[0])), (total_n2 = ($a[1] == null ? nil : $a[1])), $b}
      else if ((3)['$===']($case)) {$b = self.$get_kosei_seikaku_table(), $a = Opal.to_ary($b), (output2 = ($a[0] == null ? nil : $a[0])), (total_n2 = ($a[1] == null ? nil : $a[1])), $b}
      else if ((4)['$===']($case)) {$b = self.$get_kosei_syumi_table(), $a = Opal.to_ary($b), (output2 = ($a[0] == null ? nil : $a[0])), (total_n2 = ($a[1] == null ? nil : $a[1])), $b}
      else if ((5)['$===']($case)) {$b = self.$get_kosei_koukai_table(), $a = Opal.to_ary($b), (output2 = ($a[0] == null ? nil : $a[0])), (total_n2 = ($a[1] == null ? nil : $a[1])), $b}
      else if ((6)['$===']($case)) {$b = self.$get_kosei_sentou_table(), $a = Opal.to_ary($b), (output2 = ($a[0] == null ? nil : $a[0])), (total_n2 = ($a[1] == null ? nil : $a[1])), $b};
      result = "" + "《" + (output2) + "／" + (output1) + (total_n2) + "》";
      number = "" + (total_n1) + "," + (total_n2);
      return [result, number];
    }, $KanColle_get_kosei_table$44.$$arity = 0);
    
    Opal.def(self, '$get_bunya_table', $KanColle_get_bunya_table$45 = function $$get_bunya_table() {
      var self = this, table = nil;

      
      table = ["背景", "魅力", "性格", "趣味", "航海", "戦闘"];
      return self.$get_table_by_1d6(table);
    }, $KanColle_get_bunya_table$45.$$arity = 0);
    
    Opal.def(self, '$get_kosei_haikei_table', $KanColle_get_kosei_haikei_table$46 = function $$get_kosei_haikei_table() {
      var self = this, table = nil;

      
      table = ["人脈", "名声", "暗い過去", "古風", "口ぐせ", "幸運", "アイドル", "秘密兵器", "お嬢様", "スタイル", "外国暮らし"];
      return self.$get_table_by_2d6(table);
    }, $KanColle_get_kosei_haikei_table$46.$$arity = 0);
    
    Opal.def(self, '$get_kosei_miryoku_table', $KanColle_get_kosei_miryoku_table$47 = function $$get_kosei_miryoku_table() {
      var self = this, table = nil;

      
      table = ["素直", "クール", "優しい", "おしとやか", "けなげ", "笑顔", "ばか", "さわやか", "面白い", "えっち", "派手"];
      return self.$get_table_by_2d6(table);
    }, $KanColle_get_kosei_miryoku_table$47.$$arity = 0);
    
    Opal.def(self, '$get_kosei_seikaku_table', $KanColle_get_kosei_seikaku_table$48 = function $$get_kosei_seikaku_table() {
      var self = this, table = nil;

      
      table = ["不思議", "おおらか", "面倒見", "マジメ", "負けず嫌い", "元気", "楽観的", "丁寧", "いじわる", "自由奔放", "大胆"];
      return self.$get_table_by_2d6(table);
    }, $KanColle_get_kosei_seikaku_table$48.$$arity = 0);
    
    Opal.def(self, '$get_kosei_syumi_table', $KanColle_get_kosei_syumi_table$49 = function $$get_kosei_syumi_table() {
      var self = this, table = nil;

      
      table = ["寝る", "空想", "生き物", "読書", "食べ物", "おしゃべり", "買い物", "芸能", "おしゃれ", "入浴", "恋愛"];
      return self.$get_table_by_2d6(table);
    }, $KanColle_get_kosei_syumi_table$49.$$arity = 0);
    
    Opal.def(self, '$get_kosei_koukai_table', $KanColle_get_kosei_koukai_table$50 = function $$get_kosei_koukai_table() {
      var self = this, table = nil;

      
      table = ["暗号", "通信", "索敵", "規律", "補給", "待機", "機動", "海図", "指揮", "衛生", "整備"];
      return self.$get_table_by_2d6(table);
    }, $KanColle_get_kosei_koukai_table$50.$$arity = 0);
    
    Opal.def(self, '$get_kosei_sentou_table', $KanColle_get_kosei_sentou_table$51 = function $$get_kosei_sentou_table() {
      var self = this, table = nil;

      
      table = ["電子戦", "航空打撃戦", "航空戦", "対空戦闘", "突撃", "砲撃", "退却", "支援", "魚雷", "対潜戦闘", "夜戦"];
      return self.$get_table_by_2d6(table);
    }, $KanColle_get_kosei_sentou_table$51.$$arity = 0);
    
    Opal.def(self, '$get_senzyou_table', $KanColle_get_senzyou_table$52 = function $$get_senzyou_table() {
      var $$53, self = this, table = nil;

      
      table = ["同航戦", "反航戦", "Ｔ字有利", "Ｔ字不利", "悪天候", "悪海象（あくかいしょう）"];
      $send(table, 'each', [], ($$53 = function(i){var self = $$53.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$gsub!'](/$/, "（P231）");}, $$53.$$s = self, $$53.$$arity = 1, $$53));
      return self.$get_table_by_1d6(table);
    }, $KanColle_get_senzyou_table$52.$$arity = 0);
    
    Opal.def(self, '$get_bousou_table', $KanColle_get_bousou_table$54 = function $$get_bousou_table() {
      var $$55, self = this, table = nil;

      
      table = ["妄想", "狂戦士", "興奮", "溺愛", "慢心", "絶望"];
      $send(table, 'each', [], ($$55 = function(i){var self = $$55.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$gsub!'](/$/, "（建造弐p164）");}, $$55.$$s = self, $$55.$$arity = 1, $$55));
      return self.$get_table_by_1d6(table);
    }, $KanColle_get_bousou_table$54.$$arity = 0);
    (Opal.class_variable_set($nesting[0], '@@tables', $hash2(["BT10", "BT11", "BT12", "BT2", "BT3", "BT4", "BT5", "BT6", "BT7", "BT8", "BT9", "ETIT", "LFDT", "LFVT", "LSFT", "WPCN", "WPFA", "WPMC", "WPMCN"], {"BT10": $hash2(["name", "type", "table"], {"name": "指定個性⑩", "type": "1D6", "table": "" + "1-10　《お嬢様》\n" + "2-10　《面白い》\n" + "3-10　《いじわる》\n" + "4-10　《おしゃれ》\n" + "5-10　《指揮》\n" + "6-10　《魚雷》\n"}), "BT11": $hash2(["name", "type", "table"], {"name": "指定個性⑪", "type": "1D6", "table": "" + "1-11　《スタイル》\n" + "2-11　《えっち》\n" + "3-11　《自由奔放》\n" + "4-11　《入浴》\n" + "5-11　《衛生》\n" + "6-11　《対潜戦闘》\n"}), "BT12": $hash2(["name", "type", "table"], {"name": "指定個性⑫", "type": "1D6", "table": "" + "1-12　《外国暮らし》\n" + "2-12　《派手》\n" + "3-12　《大胆》\n" + "4-12　《恋愛》\n" + "5-12　《整備》\n" + "6-12　《夜戦》\n"}), "BT2": $hash2(["name", "type", "table"], {"name": "指定個性②", "type": "1D6", "table": "" + "1-2　《人脈》\n" + "2-2　《素直》\n" + "3-2　《不思議》\n" + "4-2　《寝る》\n" + "5-2　《暗号》\n" + "6-2　《電子戦》\n"}), "BT3": $hash2(["name", "type", "table"], {"name": "指定個性③", "type": "1D6", "table": "" + "1-3　《名声》\n" + "2-3　《クール》\n" + "3-3　《おおらか》\n" + "4-3　《空想》\n" + "5-3　《通信》\n" + "6-3　《航空打撃戦》\n"}), "BT4": $hash2(["name", "type", "table"], {"name": "指定個性④", "type": "1D6", "table": "" + "1-4　《暗い過去》\n" + "2-4　《優しい》\n" + "3-4　《面倒見》\n" + "4-4　《生き物》\n" + "5-4　《索敵》\n" + "6-4　《航空戦》\n"}), "BT5": $hash2(["name", "type", "table"], {"name": "指定個性⑤", "type": "1D6", "table": "" + "1-5　《古風》\n" + "2-5　《おしとやか》\n" + "3-5　《マジメ》\n" + "4-5　《読書》\n" + "5-5　《規律》\n" + "6-5　《対空戦闘》\n"}), "BT6": $hash2(["name", "type", "table"], {"name": "指定個性⑥", "type": "1D6", "table": "" + "1-6　《口ぐせ》\n" + "2-6　《けなげ》\n" + "3-6　《負けず嫌い》\n" + "4-6　《食べ物》\n" + "5-6　《補給》\n" + "6-6　《突撃》\n"}), "BT7": $hash2(["name", "type", "table"], {"name": "指定個性⑦", "type": "1D6", "table": "" + "1-7　《幸運》\n" + "2-7　《笑顔》\n" + "3-7　《元気》\n" + "4-7　《おしゃべり》\n" + "5-7　《待機》\n" + "6-7　《砲撃》\n"}), "BT8": $hash2(["name", "type", "table"], {"name": "指定個性⑧", "type": "1D6", "table": "" + "1-8　《アイドル》\n" + "2-8　《ばか》\n" + "3-8　《楽観的》\n" + "4-8　《買い物》\n" + "5-8　《機動》\n" + "6-8　《退却》\n"}), "BT9": $hash2(["name", "type", "table"], {"name": "指定個性⑨", "type": "1D6", "table": "" + "1-9　《秘密兵器》\n" + "2-9　《さわやか》\n" + "3-9　《丁寧》\n" + "4-9　《芸能》\n" + "5-9　《海図》\n" + "6-9　《支援》\n"}), "ETIT": $hash2(["name", "type", "table"], {"name": "侵攻効果表", "type": "2d6", "table": "" + "援軍\\n深海棲艦は徐々に力をつけ、大艦隊へとせいちょうしつつある。決戦フェイズの深海棲艦側の艦隊に、駆逐ハ級（『着任ノ書ｐ258』）が一人追加される。\n" + "海域汚染\\n特定の海域が深海棲艦の住みやすい環境になる。このセッションの艦隊戦のの各ラウンドの開始時に、深海棲艦の艦隊は誰か一人だけ【行動力】を1Ｄ6点減少できるようになる。【行動力】を消費すると、その戦場を好きなものに変更できる。\n" + "略奪\\n大勢の物資や人々を奪い、連れ去られる。鎮守府の資材がすべて1Ｄ6個失われる。\n" + "象徴破壊\\n人類に歴史的建造物や貴重な遺産、世界的な観光名所が破壊される。ＰＣ全員は【行動力】を1Ｄ6点減少する。\n" + "襲撃\\n深海棲艦の侵攻によって、鎮守府の周辺に住む人たちに大きな被害が出る。ＰＣ全員は暴走判定を行うこと。\n" + "通商破壊\\n深海棲艦の侵攻によって、通商ルートが破壊される。そのセッションの間、資材を獲得する効果が発生したとき、その資材の数がいずれも一つずつ減少する。\n" + "謎のキリ\\n謎の霧が海域を覆う。このセッションの艦隊戦中、深海棲艦はランドの開始時に、【行動力】を1Ｄ6点消費できるようになる。そのラウンドの間、消費した【行動力】の半分の値（切り捨て。0〜3点の値になる）だけ、深海棲艦全員は、艦隊戦で受けるダメージが軽減できる。この効果は累積するが、この効果で軽減できるダメージの上限は3点である。\n" + "陸地浸食\\n陸地を浸食し、海に変える。この事態に鎮守府への非難が高まる。そのセッションの間、ＰＣ全員はあらゆる判定にマイナス1の修正がつく。この侵攻以降、行動判定を行うＰＣは、判定直前に自分の【行動力】を1点消費するたび、進行による修正をすべて打ち消すことができる。\n" + "新型改造\\n深海棲艦は自らを強化しているようだ。そのセッションの決戦フェイズに登場する深海棲艦の中から一人を選ぶ。その深海棲艦をeliteのクラスを付加する。その深海棲艦がすでにeliteならflagshipに、flagshipなら改にすることもできる。\n" + "艦娘研究\\n艦娘が拿捕され、鹵獲される。一体何を企んでいるのか……？提督は、好きなＮＰＣの艦娘を一人選ぶ。深海棲艦の一人に、その艦娘の持つアビリティ一つを習得させることができる。\n" + "基地建設\\n深海棲艦は自分たちの基地を建造した。そのセッションの決戦フェイズで、深海棲艦の旗艦は、開幕雷撃戦と雷撃戦でダメージを受けなくなる。\n"}), "LFDT": $hash2(["name", "type", "table"], {"name": "艦隊敗北表", "type": "1d6", "table": "" + "敵の支援砲撃。ランダムなPC一人に損傷を一つ与える。\n" + "敵の罠。ランダムなPC一人に「アクシデント表」を一回適用する。\n" + "追い詰められる。戦場が「T字戦不利」になる。\n" + "本隊への合流。「敵部隊のサポート」発生。\n" + "盟友艦行方不明（MIA）。敵部隊の旗艦が決戦フェイズ中、対応する盟友艦の固有、または戦術アビリティをいずれか一つを修得する。\n" + "盟友艦轟沈。盟友艦は失われ「暴走表」を一回振り、暴走する。\n"}), "LFVT": $hash2(["name", "type", "table"], {"name": "艦隊勝利表", "type": "1d6", "table": "" + "支援砲撃。敵艦の中からランダムな一人に損傷を一つ与える。\n" + "士気高揚。この表を振ったPCの【命中力】が１点上昇する。\n" + "士気高揚。この表を振ったPCの【火力】が１点上昇する。\n" + "士気高揚。この表を振ったPCの【回避力】が１点上昇する。\n" + "士気高揚。この表を振ったPCの【装甲力】が１点上昇する。\n" + "絆が深まる。その盟友艦からのPCへの【感情値】が１点上昇する。\n"}), "LSFT": $hash2(["name", "type", "table"], {"name": "大規模部隊表", "type": "1d6", "table": "" + "水上打撃部隊　「脅威力：10」\n" + "空母機動部隊　「脅威力：9」\n" + "水雷戦隊　　　　「脅威力：8」\n" + "潜水艦部隊　　 「脅威力：7」\n" + "輸送部隊       「脅威力：6」\n" + "主力部隊       「脅威力：12」\n"}), "WPCN": $hash2(["name", "type", "table"], {"name": "砲開発表(燃料3/弾薬6/鋼材6/ボーキ3)", "type": "4d6", "table": "" + "開発失敗！(資材だけ失う)\n" + "開発失敗！(資材だけ失う)\n" + "三式弾(建造壱p169)\n" + "25mm連装機銃(着任p252)\n" + "41cm連装砲(着任p250)\n" + "8cm高角砲(着任p250)\n" + "15.2cm連装砲(着任p249)\n" + "魚雷(着任p252)\n" + "機銃(着任p252)\n" + "小口径主砲(着任p249)\n" + "中口径主砲(着任p249)\n" + "小口径主砲(着任p249)\n" + "中口径主砲(着任p249)\n" + "10cm連装高角砲(着任p249)\n" + "20.3cm連装砲(着任p249)\n" + "61cm四連装(酸素)魚雷(着任p252)\n" + "46cm三連装砲(着任p250)\n" + "15.5cm三連装砲(副砲)(建造壱p167)\n" + "61cm五連装(酸素)魚雷(建造壱p168)\n" + "53cm艦種(酸素)魚雷(建造壱p168)\n" + "九一式徹甲弾(建造壱p169)\n"}), "WPFA": $hash2(["name", "type", "table"], {"name": "艦載機開発表(燃料3/弾薬6/鋼材3/ボーキ6)", "type": "4d6", "table": "" + "開発失敗！(資材だけ失う)\n" + "開発失敗！(資材だけ失う)\n" + "開発失敗！(資材だけ失う)\n" + "開発失敗！(資材だけ失う)\n" + "開発失敗！(資材だけ失う)\n" + "Ju87C改(建造壱p167)\n" + "流星(建造壱p167)\n" + "紫電改二(建造壱p167)\n" + "零式艦戦52型(着任p251)\n" + "艦上戦闘機(着任p251)\n" + "偵察機(着任p251)\n" + "艦上爆撃機(着任p250)\n" + "艦上攻撃機(着任p251)\n" + "彩雲(着任p251)\n" + "彗星(着任p250)\n" + "天山(着任p251)\n" + "瑞雲(建造壱p168)\n" + "彗星一二型甲(建造壱p167)\n" + "流星改(建造壱p167)\n" + "烈風(建造壱p168)\n" + "零式水上観測機(建造壱p168)\n"}), "WPMC": $hash2(["name", "type", "table"], {"name": "特殊開発表(燃料6/弾薬3/鋼材6/ボーキ3)", "type": "2d6", "table": "" + "開発失敗！(資材だけ失う)\n" + "開発失敗！(資材だけ失う)\n" + "開発失敗！(資材だけ失う)\n" + "開発失敗！(資材だけ失う)\n" + "探照灯(建造壱p169)\n" + "電探(着任p252)\n" + "改良型艦本式タービン(着任p252)\n" + "九四式爆雷投射機(建造壱p169)\n" + "甲標的 甲(建造壱p168)\n" + "33号対水上電探(建造壱p169)\n" + "増設バルジ(中型艦)(建造壱p169)\n"}), "WPMCN": $hash2(["name", "type", "table"], {"name": "新特殊開発表(燃料6/弾薬3/鋼材6/ボーキ3)", "type": "2d6", "table": "" + "開発失敗！(資材だけ失う)\n" + "カ号観測機(建造弐p171)\n" + "九三式水中聴音機(建造弐p171)\n" + "ドラム缶(輸送用)(建造弐p171)\n" + "探照灯(建造壱p169)\n" + "電探(着任p252)\n" + "改良型艦本式タービン(着任p252)\n" + "九四式爆雷投射機(建造壱p169)\n" + "甲標的 甲(建造壱p168)\n" + "33号対水上電探(建造壱p169)\n" + "増設バルジ(中型艦)(建造壱p169)\n"})})));
    return self.$setPrefixes($rb_plus(["ET", "ACT", "EVNT", "EVKT", "EVAT", "EVET", "EVENT", "EVST", "ETHT", "ETVT", "ETGT", "ETBT", "ETMT", "ETFT", "DVT", "DVTM", "WP1T", "WP2T", "WP3T", "WP4T", "ITT", "MHT", "SNT", "SPSNT", "KTM", "BT", "KHT", "KMT", "KST", "KSYT", "KKT", "KSNT", "SNZ", "RNT"], (($a = $nesting[0].$$cvars['@@tables']) == null ? nil : $a).$keys()));
  })($nesting[0], $$($nesting, 'DiceBot'), $nesting)
})(Opal);
